import styled from 'styled-components';

import { scale130 } from '@xing-com/tokens';

export const BannerEditModeWrapper = styled.div`
  margin-bottom: ${scale130};
`;
